/* Flexsliders */

$(window).load(function() {
  
  	$(".scroller").mCustomScrollbar({
					setHeight:280,
					theme:"rounded-dark"
				});

	$('#homeSlider').flexslider({
		animation: "fade",
		directionNav: false,
		controlNav: "thumbnails",
		touch: false,
		pauseOnHover: false,
	});

	$('#historySlider').flexslider({
		animation: "slide",
		directionNav: true,
		controlNav: true,
        slideshow: false, 
		touch: true,
		pauseOnHover: true,
        animationLoop: false, 
        
	});

	$('#productSlider').flexslider({
		animation: "fade",
		directionNav: false,
		controlNav: "thumbnails",
		touch: true,
		pauseOnHover: true,
	});
  
  $('#firstSlider').flexslider({
		animation: "fade",
		directionNav: true,
		controlNav: false,
    	slideshow: false, 
		touch: true,
		pauseOnHover: true,
    	animationLoop: false, 
	});

   $('#secondSlider').flexslider({
		animation: "fade",
		directionNav: true,
		controlNav: false,
        slideshow: false, 
		touch: true,
		pauseOnHover: true,
        animationLoop: false,
	});
  
    $('#thirdSlider').flexslider({
		animation: "fade",
		directionNav: true,
		controlNav: false,
        slideshow: false, 
		touch: true,
		pauseOnHover: true,
        animationLoop: false,
	});

   $('#fourthSlider').flexslider({
		animation: "fade",
		directionNav: true,
		controlNav: false,
        slideshow: false, 
		touch: true,
		pauseOnHover: true,
	});
  
  $("#the-problem-img").height($("#the-problem-text").height());
  $("#the-solution-img").height($("#the-solution-text").height());
  
  $(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top-80
        }, 1000);
        return false;
      }
    }
  });
});
  
  $(window).scroll(function() {
		$('#the-problem-img').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideRight");
			}
		});
	});
	
	$(window).scroll(function() {
		$('#the-problem-text').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideLeft");
			}
		});
	});
  
   $(window).scroll(function() {
		$('#the-solution-img').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideRight");
			}
		});
	});
	
	$(window).scroll(function() {
		$('#the-solution-text').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideLeft");
			}
		});
	});
  
  	$(window).scroll(function() {
		$('#the-madali-difference').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideUp");
			}
		});
	});
  
  	$(window).scroll(function() {
		$('#the-madali-process').each(function(){
		var imagePos = $(this).offset().top;

		var topOfWindow = $(window).scrollTop();
			if (imagePos < topOfWindow+600) {
				$(this).addClass("slideDown");
			}
		});
	});
  
   $(".toggle1-link").click(function(event){
   event.preventDefault();
   $("#filters").slideToggle("200");
   });
  
  $(".close").click(function(event){
   event.preventDefault();
   $("#subscribe").slideToggle('200');
   });
  
});